import {dateCompareAsc, toISODateString} from '@lib/utils';
import toNumber from 'lodash/toNumber';
import {CalendarWeek} from '../types';

export const toCalendarWeek = (weekNumber: number, days: Date[]): CalendarWeek => {
  return {
    weekNumber,
    days: days.sort(dateCompareAsc).map(toISODateString),
  };
};

export const toCalendarWeeks = (daysByWeekNumber: Record<number, Date[]>): CalendarWeek[] => {
  return Object.keys(daysByWeekNumber).map((keyStr) => {
    const weekNumber = toNumber(keyStr);
    const days = daysByWeekNumber[weekNumber];

    return toCalendarWeek(weekNumber, days);
  });
};
